module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap3"
    }
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("“R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT HERE,” SAID")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USAN")]), _vm._v(" Klein. She was pale and angry. She shook her head. She rubbed the bartop with a towel. The Toussaint Saloon was packed with people who were all talking at once in little groups. They were drinking but not much. They ordered drinks and then forgot them. The telephone was tied up with people who were checking on their families and friends. They did this over and over.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s something that happens somewhere else,” said Susan Klein. “In the cities. It doesn’t happen here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madelaine reached across the bar and she put her hand on top of Susan’s. Madelaine looked down at the scarred wood.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Bart Fascelli was sucking down his second soda. His left arm was in a sling. Once again, he had hurt himself working on his gigantic diesel shovel. It did not come naturally to him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Bad man like that don’t leave those girls nothin’,” said Madelaine. “Kill them, dump them like old guts in the brush for the coyotes to eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré was standing on the other side of Bart, sipping a whiskey. He kept looking off somewhere else. Far away. A far country.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I don’t suppose it would do any good to post a reward?” said Bart, looking from Susan and Madelaine to Du Pré. Bart was rich. Very rich. He had money, at least, to offer.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I didn’t think so,” said Bart.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is maybe a good idea,” said Du Pré. “Except this guy is not a thief or a guy does things with other people, you know. He just does this alone, you know. People now will be watching all the time, you bet, I hope they don’t just shoot every stranger. This is not funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Benny Klein came in, looking tired and worn and sick.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He came up to his wife and he leaned up against the bar. He didn’t say anything. After a moment, Susan reached over and touched his face.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Benny,” she said softly, “calm down. Have a beer. Come on, now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked in the mirror. The four of them, the two women near poor Benny, who liked evil even less than he liked violence. Bart looking off and far away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I hope he don’t say he is afraid of me again, Du Pré thought. I hope this bastard gets caught today. But I don’t think that he will.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré’s thoughts flicked back and forth like a hunter’s eyes on a landscape. He sighed and sipped his whiskey.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Susan Klein was pulling beers and mixing drinks, her face sad.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I been here plenty, thought Du Pré, playing my fiddle. Happy times with my friends and neighbors, drinking and laughing and dancing. Maybe we get to do that. But we have to wait on someone with a dead heart to let us.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Gabriel,” said Bart. He had come up behind Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Unh,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What do you think, now?” said Bart. He was looking levelly into Du Pré’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He rolled a cigarette. He lit it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Plenty bad, what I think,” said Du Pré. “Maybe I call that Harvey Wallace, you remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh, yes,” said Bart.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He is with them FBI,” Du Pré went on. “Maybe he have something he can tell us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Good,” said Bart.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I also try to find Benetsee,” said Du Pré. “But he is gone. He tell me he is going to Canada, see some of his people. But I don’t know what he meant, how long he is gone, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m trying to think of something I can do,” said Bart.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You are doing it,” said Du Pré. “You can spend your money later.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Bart laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s the first thing that I think of,” he said, “you know how I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked up at the tin ceiling. Yes, Bart, I know how you are and you got more money than most countries got. It almost killed you all that money. But it did not.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You are my friend.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("My father kill your brother, long time ago.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Life, it is very strange.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré stubbed his smoke out in the ashtray. Light flashed against the ceiling, someone had opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Clouds moved, Du Pré thought. He glanced over to see who had come in.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A middle-aged couple in new heavy jackets and the sort of shoes that city people buy to go to the country in were standing inside the door, and they looked uncomfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man took the woman’s arm and led her toward the bar, he bent over and was speaking softly close to her ear. She looked at the floor and she dabbed at her eyes with a handkerchief.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Susan Klein had seen the couple and she had come out from the bar, moving very quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked at her, standing in front of them, her face grave.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They talked in low tones. Susan glanced over at Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She said one more thing to them and then she led them over to where Du Pré was sitting. Du Pré got up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“This is Mr. and Mrs. Kamp,” said Susan Klein to Du Pré. “They are the parents … of a missing girl. They wanted to talk … to you …”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Missing girl, Du Pré thought. Oh, yes, they are missing, they just up and left for hell.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The woman looked up at Du Pré. She was a tiny creature, her eyes huge in her sad face.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Shannon was …” she began.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Our daughter,” the man cut in. “She ran away a year ago … we never heard from her again.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We just want to know …” the woman said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré nodded. “The police, they call you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No,” said the man. “They haven’t … they said they haven’t been able to identify any of the victims …”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The woman had pulled a photograph from the pocket of her coat. It was an ordinary yearbook photograph, the kind kids in high school pass around.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“She looked like this,” said the woman. “Isn’t she pretty?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré took the photograph. He stared at it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("If one of them was your daughter, I would not know it, he thought, their faces had been chewed almost off, they had rotted, there was nothing there that looked like a pretty girl, like this picture.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The police won’t let us look at the bodies,” said the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No shit, thought Du Pré, you look at what we are finding out there you will not sleep again, this lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“She was so pretty …” the woman said, again.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Could you tell us anything?” said the man. “She had a birthmark on her back.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré thought of the green-brown bloated mess lying in the sagebrush, the birds pecking at it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I don’t know,” said Du Pré, lamely. “I wish I could help, you know, but you will have to wait for the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But you found them,” said the man. He was getting angry.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why can’t you tell us about Shannon?” said the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré felt his temper rise. Then it cooled. Crazy question, these are people crazy with grief, he thought, they are mad.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s a conspiracy,” said the man.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Yes, Du Pré thought, it is.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Do you know what it is like, to lose a child and not even really know what happened to her?” said the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why won’t you help us?” said the man.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He is helping you,” said Susan Klein.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Bastards,” said the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Susan narrowed her eyes. She stalked out the front door of the bar. She was gone only a couple of minutes. When she came back, she had a manila envelope in her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh, God, Susan,” said Benny.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“My husband is trying to find this animal,” said Susan Klein to the couple. “So is Gabriel, and about five hundred other cops. Cops are people. Pretty good people.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She pulled a big glossy black-and-white photo from the envelope.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Is this your daughter?” said Susan, eyes blazing.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The couple looked at the photo.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What is it?” said the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s what Gabriel found,” said Susan. “They don’t look like what you see in a funeral parlor when the cops find them. They look like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh my God,” said the man. “That’s a body.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“People aren’t good keepers,” said Susan Klein.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I don’t understand,” said the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Good,” said Susan Klein, slipping the photo back in the envelope. “Now, mister, I suggest that you take your wife and get the hell out of my bar and don’t come back for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why?” said the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Come on, Grace,” said the man, pulling on his wife’s arm.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She went with him, shaking her head.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They went out.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Susan Klein went back behind the bar.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked at her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She was lighting a cigarette with a butane lighter.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It took her four tries. Her hands were shaking. Badly.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53b917a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/7chap3.vue
// module id = 90
// module chunks = 0